export default __webpack_public_path__ + "static/media/a_m.ef42cb67.svg";